import React from 'react';

export default function PlayButton({ onPlay, translationFunction, isScMode = false }) {
  const t = translationFunction || ((key) => key); // Fallback if no translation function provided

  return (
    <div className="launch-menu">
      {/* PLD Space logo using the exact same structure as in-game */}
      <a
        href={isScMode ? undefined : "https://www.pldspace.com/"}
        target={isScMode ? undefined : "_blank"}
        rel="noopener noreferrer"
        className="dsl-logo-desktop"
        onClick={isScMode ? undefined : undefined}
        style={isScMode ? { pointerEvents: 'none' } : undefined}
      >
        <img
          src="/images/PLDSpace_Logo_White.svg"
          alt="PLD Space Logo"
          className="dsl-logo-img-desktop"
        />
      </a>
      
      {/* Play button positioned via CSS media queries */}
      <div className="play-button-container">
        <button 
          className="ui-congrats-btn play-game-btn-position"
          onClick={onPlay}
        >
          {t('launchMenu.playGame') || 'Play Game'}
        </button>
      </div>
      
      {/* Dark Star Labs attribution using exact same structure as in-game */}
      <div className="dsl-attribution">
        <a
          href={isScMode ? undefined : "https://www.darkstarlabs.io/"}
          target={isScMode ? undefined : "_blank"}
          rel="noopener noreferrer"
          style={isScMode ? { pointerEvents: 'none' } : undefined}
        >
          <div className="powered-by-text">Powered by</div>
          <div className="dark-star-labs-text">DARK STAR <span className="labs-red">LABS</span></div>
        </a>
      </div>
    </div>
  );
}